import { Injectable } from '@angular/core';
import { ApiService } from '@app/@core/utils/api.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private apiService: ApiService) {}
  private companyUrl = 'company'

  public getCompany(name: string) {
    return this.apiService.get(`${this.companyUrl}/${name}`);
  }

  public getCompanyIntegration(name: string) {
    return this.apiService.get(`${this.companyUrl}-integration/${name}`);
  }
}
